import {
	CUSTOM_ELEMENTS_SCHEMA,
	NgModule,
	NO_ERRORS_SCHEMA
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { InterceptorsProvider } from '../_services/interceptors/intercepors.provider';
import { AuthenticationModule } from '../authentication/authentication.module';
import { SharedModule } from '../shared/shared.module';
import { PipesModule } from '../shared/shared.pipes.module';
import { UserManagementRoutingModule } from './user-management-routing.module';

@NgModule({
	imports: [
		ReactiveFormsModule,
		SharedModule,
		RouterModule,
		UserManagementRoutingModule,
		TranslateModule,
		FormsModule,
		MatButtonModule,
		MatDialogModule,
		AuthenticationModule,
		PipesModule
	],
	declarations: [],
	exports: [FormsModule, ReactiveFormsModule],
	providers: [InterceptorsProvider],
	schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA]
})
export class UserManagementModule {}
